export * from "./types";
export * from "./agentIdentity";
export * from "./clientConfig";
export * from "./agentRegistry";
export * from "./eventCatalog";
export * from "./eventCatalog.legacy";
export * from "./clock";
export * from "./ids";
export * from "./erasureStrategy";
export * from "./window";
export * from "./reminderWindow"; // TA-1371 C3
export * from "./commentReply";
export * from "./metaSignedRequest";
export * from "./figures";
// TA-603 DATES2: the shop's date promises, read as verifier figures (figures.ts adds them).
export * from "./deadlines";
export * from "./concessions";
export * from "./icpRule";
// Fix C1 (F-25, section 10): the line that says CUST_ ids and bracketed tokens are placeholders.
export * from "./maskPlaceholderRule";
export * from "./heldChunks";
export * from "./freshness";
export * from "./graduation";
export * from "./autonomy";
export * from "./escalation";
export * from "./metaWebhook";
export * from "./outcomeTag";
export * from "./alerts";
export * from "./scenario";
export * from "./acknowledgement";
export * from "./routeDestination";
export * from "./arbiter";
export * from "./ghostLabel";
export * from "./reviewAsk";
export * from "./reviewThemes"; // V4 REPUTATION
export * from "./followUp";
// TA-1361: the class D and open-complaint hold every nurture path reads.
export * from "./nurtureHold";
// Loop k item OWEDECHO (decision rows 157, 158): the draft-mode echo normalization and first-message rule.
export * from "./textEcho";
export * from "./appointmentReminder";
export * from "./campaign";
export * from "./campaignRoi";
export * from "./missedCallTextBack";
export * from "./outcomeDigest";
export * from "./dailyBriefing";
// Loop item L8: Agent Brains 13.4, the KB gap tickets ranked for the weekly digest.
export * from "./knowledgeGaps";
export * from "./week";
// W1 ANALYST: the weekly dollars-first digest, the Q&A aggregates and the persona synthesis.
export * from "./analyst";
export * from "./analystQueries";
export * from "./personas";
export * from "./scoreboard"; // W7 SCOREBOARD: the precision scoreboard (B7, B13), counts over counts.
export * from "./retroGrill";
export * from "./leadCard";
// Loop item L10: the codes a consult.intent event is written and read with.
export * from "./consultIntent";
// M1: the memory save-gate and the recall-time re-screen.
export * from "./memorySaveGate";
export * from "./graduationRecord";
export * from "./shadowExit";
export * from "./patternCandidate";
export * from "./ratifiedPattern";
export * from "./envPreflight";
export * from "./clientId";
// TA-1336: the shop's display name, one per deployment, and the disclosure line it fills.
export * from "./shopDisplayName";
export * from "./writeTiers";
// T3 CHARTER (wave T): the Learning Charter shape, the agent roster and the L0 role charters.
export * from "./learningCharter";
// W2 LEARNER: the pure weekly learner (gates G0 to G11).
export * from "./learner";
// TA-1360: shrunken group rates for the learning evidence layer.
export * from "./shrinkage";
export * from "./agentRoster";
export * from "./roleCharters";
export * from "./cliFlags";
// TA-424: F-06's draft-ready latency, exported now that the db sweep calls it.
export * from "./draftLatency";
export * from "./productionFlag";
// TA-1319 fix 2: the one list of names the demo's mock marker may carry, read by the worker and the web.
export * from "./mockConnections";
// Decision list item 102(a): the fixed contact ask, read by compose and by `pnpm drafts approve`.
export * from "./contactAsk";
export * from "./sourceQuestion"; // TA-1336 C: the fixed source question and the rule for when code appends it.
// B3 CONTACT CAPTURE (Kabir 2026-10-11, ruling 2): the one definition of the email and phone shapes, and the detector.
export * from "./contactDetect";
export * from "./contactMask";
// B3 custody: AES-256-GCM per-client sealing of a captured identity, the key and flag env NAMES.
export * from "./identityCrypto";
// Loop item L6: lead quality, Shepherd stage and the expected-value call list (read only, shadow).
export * from "./leadQuality";
// TA-1313 fix round 1: the why-now signals read back from a stored call list row, pinned to assessLead.
export * from "./whyNowSignals";
// V1 STAGES: the stage ledger's pure half (transitions, dated next actions, projection rebuild).
export * from "./stageMachine";
// Loop item L7: `pnpm measure:sales`, the pure half.
export * from "./salesMeasure";
// Loop item F11: `pnpm measure:vip-pricing`, the pure half (F-11, report only).
export * from "./vipPricing";
// U2 VIP: the deterministic detection (signals, noisy-or confidence, raise-only decision).
export * from "./vipSignal";
// L11: the owner's call-prep brief, built here (pure) and printed by `pnpm drafts brief`.
export * from "./callBrief";
// Loop item V11: the teach-your-AI box's read of which write tier a note would touch (record only).
export * from "./ownerNoteTier";
// W5 OWNERIN: the idea pool and the reverse-grill (pure).
export * from "./ideaPool";
export * from "./ideaScreen";
export * from "./reverseGrill";
// Loop item V8: the occasion planner (print-only proposals; every interval awaits ratification).
export * from "./occasionPlanner";
export * from "./attributionStamp";
// Loop item QUAL1 (design Q3 to Q5): qualifyLead, record only, wired into nothing.
export * from "./qualifyLead";
// U3 QUALIFY: route, why-now and calibration of a qualifyLead result (lead.score).
export * from "./qualifyRoute";
export * from "./qualifyCalibration";
export * from "./outboundText"; // Item REG (rec 25b of the 10-03 list): the one registry of automated outbound text the send path checks.
// Loop f item HELD: the kind code a held memory fact is named by.
export * from "./heldFactKind";
// Loop f item HRES (TA-559): how a held contact_memory fact is settled, keep or supersede. Pure.
export * from "./memoryResolve";
export * from "./memoryWrites"; // Loop f item MBF: the one ACKRA_ENABLE_MEMORY_WRITES parser, shared by the worker and pnpm memory:backfill.
export * from "./handoff"; // T4 HANDOFF (Agent Brains 10, 10.1): the baton contract kinds, ack SLA, id and dropped-baton predicate.
// T2 (section 10.1): the situation read model and the run context. Pure; the loaders are in @ackra/db.
export * from "./situation";
export * from "./runContext";
// U3 QUALIFY: the lead.score flag plan.
export * from "./leadScoreFlag";
// V6 SUPPRESS: the detector flag and the closed reasons and sources.
export * from "./suppressionDetect";
// TA-1336: competitor mentions customers make in DMs, the flag, closed sets, prefilter and verifier.
export * from "./competitorIntel";
// TA-1371 C5: the owner's hand reply outranks the day's scheduled plays at the arbiter, the flag and the admission.
export * from "./ownerTurnPrecedence";
// R8.3 (TA-84): the closed list of explicit opt-outs the detector writes on with no person or model in the loop.
export * from "./optOutPhrases";
// U4 REPLYFULL (Agent Brains 5.1, 5.3): the sales mode, intents, warm-ups, contact moments and the [LEAD] slot lines.
export * from "./salesMode";
export * from "./contactMoment";
export * from "./replyLead";

// U1 RESEARCH (Agent Brains 5.1, B2): the codes-only lead card, its DM signals and the never-reveal check.
export * from "./dmSignals";
export * from "./researchCard";
export * from "./cardReveal";
export * from "./researchFlags";

// V2 SHEPHERD (Agent Brains 5.5 to 5.8): the pure proposal planner and the shared scheduled-task spec shape.
export * from "./shepherdPlan";
export * from "./agentScheduleSpec";
export * from "./marketingOptIn";

// W3 LESSONS (B4, B16): the objective-event lessons ledger, its fixed templates and the weekly consolidation.
export * from "./lessons";
// W4 SIGNALS (Agent Brains 13.4, B3, B15): correction attribution, the invisible-failure detector and surprise ordering.
export * from "./attribution";
export * from "./invisibleFailure";
export * from "./surprise";
// X1 AUTH: base32, TOTP (RFC 6238) and the session, lockout and password policy.
export * from "./base32";
export * from "./totp";
export * from "./authPolicy";
export * from "./authSecrets";
export * from "./catalog"; // X2 CATALOG: product insert guards, the CSV reader, media rights.
export * from "./railPicks";
export * from "./railCatalogPort";
export * from "./railInputs";
export * from "./offerWords";

// X4 TEAM (CLAUDE.md sections 3, 7, 8): who a thread is handed to and how late a person is running.
export * from "./teamRouting";

// Y2 ONBOARD (CLAUDE.md sections 3, 5, 10): the onboarding run's states, steps, halt reasons and funnel definitions.
export * from "./onboarding";
// Y5 BILLING (CLAUDE.md sections 0.5, 3, 4; decision row 271): plan tiers, premium flags, the billing state. No price anywhere.
export * from "./billing";

// B1 FUNNEL LEDGER (Kabir 2026-10-11, ruling "funnel ledger"): stage vocabulary, per-thread timeline, report.
export * from "./funnel";
// B5 HOLDOUT (Kabir 2026-10-11, ruling 6): arm assignment, sample size, intention-to-treat analysis. Pure; nothing assigns live traffic.
export * from "./experiment";
// B2 REVENUE CAPTURE (Kabir 2026-10-11, ruling 4): analytic price band, amount-or-unknown, realized revenue fold.
export * from "./priceBand";
export * from "./revenue";
// B2 OWNER BASELINE (ruling 4): the owner's stated numbers, evidence kind owner.stated, never merged into measured figures.
export * from "./shopBaseline";
// B1 FUNNEL on the weekly scoreboard: the stored funnel block and its digest lines (figures from funnel.ts, in code).
export * from "./scoreboardFunnel";
// R7b VOICE GATE (CLAUDE.md sections 2 and 3): R7a's surface tests, copied so the gate measures a draft as the bands were measured; pinned equal in packages/agents/src/voiceSurfaceCopy.test.ts.
export * from "./voiceSurface";
// D09 plan 2 (TA-1289): consult.summarized's vocabulary (the closed next-step list and the calendar-day shape).
export * from "./callSummary";
// TA-1360 learning feed: per-shop reply evidence (the reply-chance model aggregates, pinned to the committed model file).
export * from "./replyEvidence";
